import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import "../../provider-section/contract-management/delete-template-popup.scss";

interface DeleteReviewPopupProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
}
const DeleteReviewPopup = ({
  open,
  onClose,
  onDelete,
}: DeleteReviewPopupProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: "delete-dialog-paper" }}
    >
      <DialogContent className="delete-dialog-content">
        <div className="icon-wrapper">
          <WarningAmberRoundedIcon className="warning-icon" />
        </div>

        <Typography className="title">Delete Review</Typography>

        <Typography className="message">
          Do you want to delete your review?
        </Typography>
      </DialogContent>

      <DialogActions className="actions">
        <Button
          variant="outlined"
          className="cancel-delete-btn"
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          color="error"
          className="delete-btn"
          onClick={onDelete}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteReviewPopup;
